import { useRef } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { operationsRpc } from '@/lib/operations';
export function useOperationIntent(scope: string) {
  const { organization, profile } = useAuth();
  const cache = useRef(new Map<string, string>());
  const prefix = `klothiq.operation:${organization?.id}:${profile?.id}:${scope}:`;
  function read(op: string) {
    try {
      return sessionStorage.getItem(prefix + op);
    } catch {
      return null;
    }
  }
  function complete(op: string) {
    cache.current.delete(prefix + op);
    try {
      sessionStorage.removeItem(prefix + op);
    } catch {
      /* memory still works */
    }
  }
  return {
    key(op: string) {
      const key = cache.current.get(prefix + op) || read(op) || crypto.randomUUID();
      cache.current.set(prefix + op, key);
      try {
        sessionStorage.setItem(prefix + op, key);
      } catch {
        /* IDs only */
      }
      return key;
    },
    complete,
    async recover(op: string) {
      const key = cache.current.get(prefix + op) || read(op);
      if (!key) return null;
      const result = await operationsRpc<{
        purchase_id?: string;
        product_id?: string;
        schema_version_id?: string;
        version?: number;
        variant_ids?: string[];
      } | null>('get_operation_result_v1', { p_request_key: key });
      if (result) complete(op);
      return result;
    },
  };
}
